module.exports = __webpack_public_path__ + "img/galeria-vertebrados1.8aa56cdf.jpg";